import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CartService } from '../../service/cart.service';
import { SpinnerService } from '../../service/spinner.service';
import {  finalize, Subscription } from 'rxjs';
import { StatusCart } from '@/enum/statusCart';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cartdetails',
  templateUrl: './cartdetails.page.html',
  styleUrls: ['./cartdetails.page.scss']
})
export class CartdetailsPage implements OnInit, OnDestroy {
  dataForm: FormGroup;
  public cart_id: string;
  public StatusCart: typeof StatusCart = StatusCart;
  private unsubscribe: Subscription[] = [];
  public typeStatus : number
  public creation : string;
  public expiration : string;
  public status : string;
  public amount : string;

  constructor(private formBuilder: FormBuilder, private routerRedirect: Router, private router: ActivatedRoute, private cartService: CartService,
    private spinnerService: SpinnerService, private translateService: TranslateService) { }

  ngOnInit() {
    this.cart_id = this.router.snapshot.paramMap.get('id')
    this.dataForm = this.formBuilder.group({
      barcode: [''],
      customer: [''],
      customer_reference: [''],
      amount: [''],
      status: [''],
      creation_date: [''],
      time_to_live: [''],
      user_id: [''],
    });

    if (this.cart_id) {
      this.unsubscribe.push(
        this.cartService.getById(this.cart_id).pipe(finalize(() => {
          this.spinnerService.hide();
        })).subscribe(val => {
            this.dataForm.patchValue({
              barcode: val.barcode,
              customer: val.client,
              customer_reference: val.client_reference,
              amount: val.amount,
              status: this.translateService.instant(this.StatusCart[val.status]),
              creation_date: new Date(val.creation_date).toLocaleDateString() + " " + new Date(val.creation_date).toLocaleTimeString(),
              time_to_live: val.expiration_date,
              user_id: val.user_id,
            });
            this.typeStatus = val.status;
            this.creation = val.creation_date;
            this.expiration = val.expiration;
            this.status = this.translateService.instant(this.StatusCart[val.status]);
            this.amount = val.amount;

          }
        ));
    }
  }

  redirectCart() {
    this.routerRedirect.navigate(['/transaction'],  { queryParams: { cartid: this.cart_id } })
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(s => s.unsubscribe());
  }
}
